/*
API requests to the plandem backend
*/
import { apiRequest } from '../../plugins/core/dd.data.connect.js'

export const allEventTypes = (params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('GET', `/event-types`, null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e)
      })
    })
    return p
}

export const allEventSeverities = (params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('GET', `/event-severities`, null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e)
      })
    })
    return p
}

export const saveUnitTypeEvent = (data) => {
    var p = new Promise((resolve, reject) => {
        let method
        let url
        
        if(data.id){
            url =  `/unit-type-events/${data.id}`
            method = 'PUT'
        }
        else{
            url =  `/unit-type-events`
            method = 'POST'
        }        
        apiRequest(method, url, data).then((res) => {            
            resolve(res.data.data)
        }).catch((e) => {
            reject(e);
        })    
    })
    return p
}

export const saveUnitTypeActionDoneEvent = (data) => {
  var p = new Promise((resolve, reject) => {
      let method
      let url

      if(!data.parentUnitTypeEventActionId || data.parentUnitTypeEventActionId == 0){
        reject("UnitTypeEventActionId not given or 0. This data field is mandatory for saveUnitTypeActionDoneEvent")
      }
      url    = `/unit-type-event-actions/${data.parentUnitTypeEventActionId}/done-event`
      method = 'POST'            
      apiRequest(method, url, data).then((res) => {          
          resolve(res.data.data)
      }).catch((e) => {
          reject(e);
      })    
  })
  return p
}

export const getPredefinedEvents = (params) => {
  var p = new Promise((resolve, reject) => {
      let method
      let url

      url    = `/predefined-events`
      method = 'GET'            
      apiRequest(method, url, null, params).then((res) => {          
          resolve(res.data)
      }).catch((e) => {
          reject(e);
      })    
  })
  return p
}


export const saveUnitTypeActionCancelEvent = (data) => {
  var p = new Promise((resolve, reject) => {
      let method
      let url

      if(!data.parentUnitTypeEventActionId || data.parentUnitTypeEventActionId == 0){
        reject("AssetUnitTypeEventActionId not given or 0. This data field is mandatory for saveUnitTypeActionDoneEvent")
      }
      url    = `/unit-type-event-actions/${data.parentUnitTypeEventActionId}/cancel-event`
      method = 'POST'            
      apiRequest(method, url, data).then((res) => {          
          resolve(res.data.data)
      }).catch((e) => {
          reject(e);
      })    
  })
  return p
}

export const saveUnitTypeEventAction = (data) => {
    var p = new Promise((resolve, reject) => {
        let method
        let url
  
        if(data.id){
          url =  `/unit-type-event-actions/${data.id}`
          method = 'PUT'
        }
        else{
          url =  `/unit-type-event-actions`
          method = 'POST'
        }         
        apiRequest(method, url, data).then((res) => {          
            resolve(res.data.data)
        }).catch((e) => {
            reject(e);
        })    
    })
    return p 
} 

export const getUnitTypeEvent = (data, params) => {
    var p = new Promise((resolve, reject) => {
        apiRequest('GET', `/unit-type-events/${data.id}`, null, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
      return p
}

export const getUnitTypeEvents = (data, params) => {
  var p = new Promise((resolve, reject) => {
      apiRequest('GET', `/unit-type-events`, null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e)
      })
    })
    return p
}

export const saveAssetUserEvent = (data, params) => {
  var p = new Promise((resolve, reject) => {
      let method
      let url

      if(!data.assetId){
        throw Error("assetId is mandatory")        
      }

      url =  `/assets/${data.assetId}/user-events`
      method = 'POST'

      apiRequest(method, url, data).then((res) => {          
          resolve(res.data.data)
      }).catch((e) => {
          reject(e);
      })    
  })
  return p 
}

export const getEventHistory = (data, params) => {
  
  var p = new Promise((resolve, reject) => {
      apiRequest('GET', `/events/historic/${data.date}`, null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e)
      })
    })
    return p
}

export const getActionHistory = (data, params) => {
  var p = new Promise((resolve, reject) => {
      apiRequest('GET', `/actions/historic/${data.date}`, null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e)
      })
    })
    return p
}


/*
export const getUnitTypeEventWorkflow = (params) => {
    var p = new Promise((resolve, reject) => {
        apiRequest('GET', `/events/34/workflows`, null, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {
          reject(e)
        })
      })
      return p
}
*/

